import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

const EmployeeDataContext = createContext();

export const EmployeeDataProvider = ({ children }) => {
  const [profileMenuName, setProfileMenuName] = useState(null);
  const [profileImage, setProfileImage] = useState(null);

  const [loader, setLoader] = useState(true);
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);

  const fetchViewEmployersData = async () => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}employee/viewUser`,
      data: { id: decode.user_id },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then((response) => {
        if (response.data.status === true) {
          setProfileMenuName(response.data.data);
        }
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (["RECRUITER","CLIENTCOORDINATOR","EMPLOYEE"].includes(decode.role)) {
      fetchViewEmployersData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <EmployeeDataContext.Provider
      value={{
        profileMenuName,
        profileImage,
        loader,
        setProfileMenuName,
        setProfileImage,
        setLoader,
        fetchViewEmployersData,
      }}
    >
      {children}
    </EmployeeDataContext.Provider>
  );
};

export const useEmployeeDetails = () => React.useContext(EmployeeDataContext);
